import React from "react";
import { CustomToggleField } from "customComponents/Form";
import { CustomFieldGroup } from "customComponents/Form";
import {
  Modal,
  Row,
  Col,
  Input,
  Button,
  UncontrolledTooltip,
  Form,
  FormGroup,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CreateModal = ({
  settingsModal,
  schedulerModal,
  pageSelectionModal,
  userSelectionModal,
  reportPageSelectionModal,
  singleUserSelectionModal,
  // data, //Commented By Joef: Not needed here
  i,
  ...props
}) => {
  return (
    <>
      <Modal
        size="lg"
        className="modal-dialog-centered"
        isOpen={settingsModal.show}
        toggle={() => props.closeSettingsModal()}
        key={i}
      >
        <div className="modal-body">
          <h5 className="modal-title mb-0">
            {settingsModal.record.Name} Settings
          </h5>
          <Form onSubmit={props.handleChangeSettings}>
            <Row>
              <CustomToggleField
                onChange={props.onToggle}
                label="Show on mobile?"
                type="checkbox"
                id={`mobile${i}`}
                name="Mobile"
                defaultValue={
                  !settingsModal.record.hasOwnProperty("Details") ||
                  !settingsModal.record.Details.hasOwnProperty("Settings") ||
                  !settingsModal.record.Details.Settings.hasOwnProperty(
                    "Mobile"
                  ) ||
                  settingsModal.record.Details.Settings.Mobile
                }
                defaultChecked={
                  !settingsModal.record.hasOwnProperty("Details") ||
                    !settingsModal.record.Details.hasOwnProperty("Settings") ||
                    !settingsModal.record.Details.Settings.hasOwnProperty(
                      "Mobile"
                    ) ||
                    settingsModal.record.Details.Settings.Mobile !== true
                    ? false
                    : true
                }
              />
            </Row>
            <Row>
              <CustomToggleField
                onChange={props.onToggle}
                label="Show in desktop?"
                type="checkbox"
                i={i}
                id={`desktop${i}`}
                name="Desktop"
                defaultValue={
                  !settingsModal.record.hasOwnProperty("Details") ||
                  !settingsModal.record.Details.hasOwnProperty("Settings") ||
                  !settingsModal.record.Details.Settings.hasOwnProperty(
                    "Mobile"
                  ) ||
                  settingsModal.record.Details.Settings.Desktop
                }
                defaultChecked={
                  !settingsModal.record.hasOwnProperty("Details") ||
                    !settingsModal.record.Details.hasOwnProperty("Settings") ||
                    !settingsModal.record.Details.Settings.hasOwnProperty(
                      "Mobile"
                    ) ||
                    settingsModal.record.Details.Settings.Desktop !== true
                    ? false
                    : true
                }
              />
            </Row>
            <Row>
              <CustomToggleField
                label="Show Report Tabs in Desktop View?"
                onChange={props.onToggle}
                type="checkbox"
                id="showtabs"
                name="ShowTabs"
                i={i}
                defaultChecked={
                  settingsModal.record.hasOwnProperty("Details") &&
                  settingsModal.record.Details.hasOwnProperty("Settings") &&
                  settingsModal.record.Details.Settings.hasOwnProperty(
                    "ShowTabs"
                  ) &&
                  settingsModal.record.Details.Settings.ShowTabs
                }
                defaultValue={
                  settingsModal.record.hasOwnProperty("Details") &&
                  settingsModal.record.Details.hasOwnProperty("Settings") &&
                  settingsModal.record.Details.Settings.hasOwnProperty(
                    "ShowTabs"
                  ) &&
                  settingsModal.record.Details.Settings.ShowTabs
                }
              />
            </Row>
            <Row>
              <CustomToggleField
                onChange={props.onToggle}
                label="Turn on RLS?"
                type="checkbox"
                name="RLS"
                id="rls"
                i={i}
                defaultChecked={
                  settingsModal.record.hasOwnProperty("Details") &&
                  settingsModal.record.Details.hasOwnProperty("Settings") &&
                  settingsModal.record.Details.Settings.hasOwnProperty("RLS") &&
                  settingsModal.record.Details.Settings.RLS
                }
                defaultValue={
                  settingsModal.record.hasOwnProperty("Details") &&
                  settingsModal.record.Details.hasOwnProperty("Settings") &&
                  settingsModal.record.Details.Settings.hasOwnProperty("RLS") &&
                  settingsModal.record.Details.Settings.RLS
                }
              />
            </Row>

            {settingsModal.record.hasOwnProperty("Details") &&
              settingsModal.record.Details.hasOwnProperty("Settings") &&
              settingsModal.record.Details.Settings.RLS ? (
              <Row
                style={{
                  display:
                    settingsModal.record.Details.Settings.RLS === true
                      ? "block"
                      : "none",
                }}
              >
                <Col style={{ position: "relative" }} className="mt-3">
                  <CustomFieldGroup
                    id="Role"
                    type="textarea"
                    name="Role"
                    label="Role"
                    placeholder="Enter Role"
                    defaultValue={
                      settingsModal.record.Details.Settings.Role || ""
                    }
                    onChange={props.onToggle}
                    required={true}
                  />
                  {/* {ExternalLink(
                    "Watch Training Here",
                    "https://training.etani.com.au/courses/",
                    "_blank"
                  )} */}
                  <div
                    style={{ position: "absolute", top: "-5px", left: "50px" }}
                  >
                    <i
                      className="fas fa-question-circle text-danger"
                      id={`img${i}`}
                    />
                    <UncontrolledTooltip target={`img${i}`} placement="top">
                      <img
                        alt="_"
                        style={{
                          marginLeft: "-8px",
                          marginTop: "-5px",
                          marginBottom: "-5px",
                        }}
                        src={`data:image/png;base64,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`}
                      />
                    </UncontrolledTooltip>
                  </div>
                </Col>
              </Row>
            ) : null}
            <Row>
              <Col className="mt-3">
                <CustomFieldGroup
                  id={`description${i}`}
                  type="textarea"
                  name="Description"
                  label="Description"
                  placeholder="Enter Description"
                  defaultValue={settingsModal.record.Description || ""}
                  onChange={props.inputChange}
                />
              </Col>
            </Row>
            <Row>
              <Col className="d-flex mt-3">
                <Button
                  className="btn-icon btn-3"
                  size="sm"
                  style={{
                    color: `${props.textColor}`,
                    borderColor: `${props.bgColor}`,
                    backgroundColor: `${props.bgColor}`,
                  }}
                  type="button"
                  onClick={() =>
                    props.openUserSelectionModal(settingsModal.record, true)
                  }
                >
                  <i className="ni ni-bag-17" />
                  <span className="btn-inner--text">Select Users</span>
                </Button>
                <span>{`${userSelectionModal.selected &&
                  userSelectionModal.selected.length
                  ? userSelectionModal.selected.length
                  : settingsModal.record.Details &&
                    settingsModal.record.Details.recipient &&
                    settingsModal.record.Details.recipient.length
                    ? settingsModal.record.Details.recipient.length
                    : "No"
                  } ${userSelectionModal.selected &&
                    userSelectionModal.selected.length > 1
                    ? "users"
                    : settingsModal.record.Details &&
                      settingsModal.record.Details.recipient &&
                      settingsModal.record.Details.recipient.length > 1
                      ? "users"
                      : "user"
                  } selected`}</span>
              </Col>
            </Row>
            {!(
              settingsModal.record.hasOwnProperty("Details") &&
              settingsModal.record.Details.hasOwnProperty("Settings") &&
              settingsModal.record.Details.Settings.hasOwnProperty("RLS") &&
              settingsModal.record.Details.Settings.RLS
            ) && settingsModal.record.Status === 4 ? (
              <Row>
                <Col className="d-flex mt-3">
                  <Button
                    className="btn-icon btn-3"
                    size="sm"
                    style={{
                      color: `${props.textColor}`,
                      borderColor: `${props.bgColor}`,
                      backgroundColor: `${props.bgColor}`,
                    }}
                    type="button"
                    onClick={() =>
                      props.openSchedulerModal(settingsModal.record, true)
                    }
                  >
                    <i className="fas fa-clock" />
                    <span className="btn-inner--text">
                      {!settingsModal.record.Details.Schedule
                        ? "Schedule Email"
                        : "Update Schedule"}
                    </span>
                  </Button>
                  {settingsModal.record.Details.Schedule ? (
                    <Button
                      className="btn-icon btn-3"
                      size="sm"
                      style={{
                        color: `${props.textColor}`,
                        borderColor: `${props.bgColor}`,
                        backgroundColor: `${props.bgColor}`,
                      }}
                      type="button"
                      onClick={() => props.handleRemoveSchedule()}
                    >
                      <i className="fas fa-calendar-times" />
                      <span className="btn-inner--text">Remove Schedule</span>
                    </Button>
                  ) : null}
                </Col>
              </Row>
            ) : null}
            {!(
              settingsModal.record.hasOwnProperty("Details") &&
              settingsModal.record.Details.hasOwnProperty("Settings") &&
              settingsModal.record.Details.Settings.hasOwnProperty("RLS") &&
              settingsModal.record.Details.Settings.RLS
            ) && settingsModal.record.Status === 4 ? (
              <Row>
                <Col className="d-flex mt-3">
                  <Button
                    className="btn-icon btn-3"
                    size="sm"
                    style={{
                      color: `${props.textColor}`,
                      borderColor: `${props.bgColor}`,
                      backgroundColor: `${props.bgColor}`,
                    }}
                    type="button"
                    onClick={() =>
                      props.openPageSelectionModal(
                        settingsModal.record,
                        true,
                        true
                      )
                    }
                  >
                    <i
                      className={
                        !settingsModal.record.Details.ExportToPDF
                          ? "fas fa-toggle-on"
                          : "fas fa-pen-square"
                      }
                    />
                    <span className="btn-inner--text">
                      {!settingsModal.record.Details.ExportToPDF
                        ? "Turn on Export to PDF for Client"
                        : " Update Export to PDF for Client"}
                    </span>
                  </Button>
                  {settingsModal.record.Details.ExportToPDF ? (
                    <Button
                      className="btn-icon btn-3"
                      size="sm"
                      style={{
                        color: `${props.textColor}`,
                        borderColor: `${props.bgColor}`,
                        backgroundColor: `${props.bgColor}`,
                      }}
                      type="button"
                      onClick={() => props.handleRemoveExportToPDF()}
                    >
                      <i className="fas fa-toggle-on" />
                      <span className="btn-inner--text">
                        Turn off Export to PDF for Client
                      </span>
                    </Button>
                  ) : null}
                </Col>
              </Row>
            ) : null}
            <div className="modal-footer px-0 pb-0">
              <Button
                color="primary"
                style={{
                  color: `${props.textColor}`,
                  borderColor: `${props.bgColor}`,
                  backgroundColor: `${props.bgColor}`,
                }}
                type="submit"
              >
                Save
              </Button>
              <Button
                color="secondary"
                outline
                style={{
                  color: `${props.bgColor}`,
                  borderColor: `${props.bgColor}`,
                }}
                type="button"
                onClick={() => props.closeSettingsModal()}
              >
                Close
              </Button>
            </div>
          </Form>
        </div>
      </Modal>

      {/* user selection Modal */}

      {/* <CustomModal
        title="Select User"
        subtitle={null}
        fieldGroup={null}
        list={props.userSelectList()}
        isOpen={userSelectionModal.show}
        searchInput={props.handleUserSearch}
        toggle={() => props.closeUserSelectionModal()}
        closeButton={() => props.closeUserSelectionModal()}
        submitButton={(e) => {
          e.preventDefault();
          if (userSelectionModal.settings) props.handleUserSelect();
          else {
            props.handleUpdate(
              "/api/customReport/updateLive?id=" +
                userSelectionModal.report.ReportID,
              4,
              {
                report: userSelectionModal.report,
                recipient: userSelectionModal.selected
              }
            );
          }
        }}
        headerButtons={
          <ButtonGroup>
            <Button
              style={{
                backgroundColor: `${props.bgColor}`,
                color: `${props.textColor}`,
                borderColor: `${props.bgColor}`
              }}
              type="button"
              size="sm"
              onClick={() => props.selectAll()}
            >
              <i className="ni ni-fat-add "></i>
              Select All
            </Button>
            <Button
              style={{
                color: `${props.bgColor}`,
                borderColor: `${props.bgColor}`
              }}
              data-dismiss="modal"
              type="button"
              size="sm"
              outline
              onClick={() => props.unselectAll()}
            >
              <i className="ni ni-fat-delete "></i>
              Unselect All
            </Button>
          </ButtonGroup>
        }
      /> */}

      {/* page selection modal */}

      {/* <CustomModal
        title="Select Page"
        subtitle={null}
        fieldGroup={null}
        list={props.pageSelectList()}
        isOpen={pageSelectionModal.show}
        searchInput={props.handlePageSearch}
        toggle={() => props.closePageSelectionModal()}
        closeButton={() => props.closePageSelectionModal()}
        submitButton={(e) => {
          e.preventDefault();
          props.handlePageSelect();
        }}
        headerButtons={
          <ButtonGroup>
            <Button
              style={{
                backgroundColor: `${props.bgColor}`,
                color: `${props.textColor}`,
                borderColor: `${props.bgColor}`
              }}
              type="button"
              size="sm"
              onClick={() => props.selectPageAll()}
            >
              <i className="ni ni-fat-add "></i>
              Select All
            </Button>
            <Button
              style={{
                color: `${props.bgColor}`,
                borderColor: `${props.bgColor}`
              }}
              data-dismiss="modal"
              type="button"
              size="sm"
              outline
              onClick={() => props.unselectPageAll()}
            >
              <i className="ni ni-fat-delete "></i>
              Unselect All
            </Button>
          </ButtonGroup>
        }
      /> */}

      {/* report page selection modal */}

      {/* <CustomModal
        headerButtons={null}
        title={"Cloning Report: " + reportPageSelectionModal.report.Name}
        list={props.reportPageSelectList()}
        isOpen={reportPageSelectionModal.show}
        searchInput={props.handleReportPageSearch}
        toggle={() => props.closeReportPageSelectionModal()}
        subtitle={<h5 className="h5 mt-3 mb-2"> Select Page:</h5>}
        closeButton={() => props.closeReportPageSelectionModal()}
        submitButton={(e) => {
          e.preventDefault();
          props.handleReportPageSelect();
        }}
        fieldGroup={
          <Row>
            <Col>
              <CustomFieldGroup
                id="Name"
                name="Name"
                label="New Report Name"
                placeholder="Enter New Report Name"
                type="text"
                onChange={props.handleReportPageNameChange}
                defaultValue={reportPageSelectionModal.Name || ""}
                required={true}
              />
            </Col>
          </Row>
        }
      /> */}

      {/* single user selection modal */}

      {/* <CustomModal
        title="Select User"
        subtitle={null}
        fieldGroup={null}
        submitButton={null}
        headerButtons={null}
        list={props.singleUserSelectList()}
        searchInput={props.handleSingleUserSearch}
        isOpen={singleUserSelectionModal.show}
        toggle={() => props.closeSingleUserSelectionModal()}
        closeButton={() => props.closeSingleUserSelectionModal()}
      /> */}

      {/* create modal */}

      {/* <Modal
        size="lg"
        className="modal-dialog-centered"
        isOpen={props.createModal.sho}
        toggle={() => props.closeCreateModal()}
      >
        <div className="modal-body">
          <h5 className="modal-title mb-0">Create Report</h5>
        </div>
        <Row className="modal-footer py-0">
          <Button
            data-dismiss="modal"
            type="submit"
            style={{
              color: `${props.textColor}`,
              borderColor: `${props.bgColor}`,
              backgroundColor: `${props.bgColor}`
            }}
          >
            Save
          </Button>
          <Button
            data-dismiss="modal"
            color="secondary"
            type="button"
            style={{
              color: `${props.bgColor}`,
              borderColor: `${props.bgColor}`
            }}
            outline
            onClick={() => props.closeSchedulerModal()}
          >
            Cancel
          </Button>
        </Row>
      </Modal> */}

      {/* // scheduler modal */}

      <Modal
        size="lg"
        className="modal-dialog-centered"
        isOpen={schedulerModal.show}
        toggle={() => props.closeSchedulerModal()}
      >
        <div className="modal-body">
          <h5 className="modal-title mb-0">Email Scheduler</h5>
          <Form onSubmit={props.handleSchedulerSubmit}>
            {schedulerModal.record.Scheduled ? (
              <>
                <Row>
                  <CustomToggleField
                    label="Repeat?"
                    type="checkbox"
                    i={i}
                    id={`Repeat${i}`}
                    name="Repeat"
                    defaultValue={schedulerModal.record.Repeat || false}
                    defaultChecked={schedulerModal.record.Repeat || false}
                    onChange={props.inputSchedularChange}
                  />
                  {schedulerModal.record.Scheduled &&
                    schedulerModal.record.Repeat ? (
                    <Col lg="12" className="mt-3">
                      <FormGroup className="w-50">
                        <label>Notification Frequency</label>
                        <Input
                          type="select"
                          name="Frequency"
                          value={schedulerModal.record.Frequency}
                          onChange={props.handleSchedulerInputChange}
                          required={true}
                        >
                          <option value="">
                            Select notification frequency
                          </option>
                          <option value="daily">Daily</option>
                          <option value="weekly">Weekly</option>
                          <option value="monthly">Monthly</option>
                          <option value="quarterly">Quarterly</option>
                          <option value="annually">Annually</option>/
                        </Input>
                      </FormGroup>
                    </Col>
                  ) : null}
                </Row>
                <Row>
                  <Col lg="12">
                    <FormGroup className="w-50">
                      <CustomFieldGroup
                        id="Time"
                        name="Time"
                        type="time"
                        required={true}
                        label="Schedule Time"
                        placeholder="Select Schedule Time"
                        onChange={props.handleSchedulerInputChange}
                        defaultValue={schedulerModal.record.Time}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12">
                    <FormGroup>
                      <label>Schedule Date</label>
                      <DatePicker
                        id={`Date${i}`}
                        required={true}
                        onChange={props.handleSchedulerDateChange}
                        value={schedulerModal.record.Date}
                        selected={props.startDate}
                        className="form-control w-25 "
                      // onChange={(date) => setStartDate(date)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {schedulerModal.record.Scheduled &&
                  schedulerModal.record.Repeat ? (
                  <>
                    <Row className="mt--2">
                      {schedulerModal.record.Frequency &&
                        (schedulerModal.record.Frequency === "monthly" ||
                          schedulerModal.record.Frequency === "quarterly" ||
                          schedulerModal.record.Frequency === "annually") ? (
                        <CustomToggleField
                          label="Days before the end of the month?"
                          type="checkbox"
                          i={i}
                          id={`Reverse${i}`}
                          name="Reverse"
                          defaultValue={schedulerModal.record.Reverse || false}
                          defaultChecked={
                            schedulerModal.record.Reverse || false
                          }
                          onChange={props.inputSchedularChange}
                        />
                      ) : null}
                    </Row>
                    <Row className="mt-3 text-danger">
                      <Col>
                        {props.displayScheduler(
                          schedulerModal.record.Frequency
                        )}
                      </Col>
                    </Row>
                  </>
                ) : null}
                <Row className="mt-2">
                  <Col>
                    <Button
                      size="sm"
                      style={{
                        color: `${props.textColor}`,
                        borderColor: `${props.bgColor}`,
                        backgroundColor: `${props.bgColor}`,
                      }}
                      outline
                      className="mr-3"
                      onClick={() =>
                        props.openPageSelectionModal(settingsModal.record, true)
                      }
                    >
                      Select Pages
                    </Button>
                    {`${pageSelectionModal.selected &&
                      pageSelectionModal.selected.length
                      ? pageSelectionModal.selected.length
                      : schedulerModal.record.Page &&
                        schedulerModal.record.Page.length
                        ? schedulerModal.record.Page.length
                        : "No"
                      } ${pageSelectionModal.selected &&
                        pageSelectionModal.selected.length > 1
                        ? "pages"
                        : schedulerModal.record.Page &&
                          schedulerModal.record.Page.length > 1
                          ? "pages"
                          : "page"
                      } selected`}
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <p className="text-muted">
                      *The schedule follows AEST (GMT +10.00)
                    </p>
                    <p className="text-muted">
                      *The actual email may be sent later than the set time
                      depending on the number in queue and the number of pages
                      you selected.
                    </p>
                  </Col>
                </Row>
              </>
            ) : null}

            <Row className="modal-footer py-0">
              <Button
                data-dismiss="modal"
                type="submit"
                style={{
                  color: `${props.textColor}`,
                  borderColor: `${props.bgColor}`,
                  backgroundColor: `${props.bgColor}`,
                }}
              >
                Save
              </Button>
              <Button
                data-dismiss="modal"
                color="secondary"
                type="button"
                style={{
                  color: `${props.bgColor}`,
                  borderColor: `${props.bgColor}`,
                }}
                outline
                onClick={() => props.closeSchedulerModal()}
              >
                Cancel
              </Button>
            </Row>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default CreateModal;
